import React from "react";
import ListItemRow from "./ListItemRow";

function ListItems({listItems, removeListItem, disabled}) {
	return (
		<table className={"table table-sm  table-striped table-light"}>
			<thead className={"table-dark"}>
			<tr>
				<th>Item</th>
				<th>Actions</th>
			</tr>
			</thead>
			<tbody>
			{listItems.map((listItem) => {
				return (
					<ListItemRow removeListItem={removeListItem} listItem={listItem} key={listItem.id} disabled={disabled}/>
				);
			})}
			</tbody>

		</table>
	);
}

export default ListItems;
